export default {"src":"/_next/static/media/LongTree.06e1d494.svg","height":231,"width":103,"blurWidth":0,"blurHeight":0};